import { useEffect, useRef } from "react";

const PrintBase64Pdf = ({ base64, open }) => {
	const iframeRef = useRef(null);

	useEffect(() => {
		if (open && base64) {
			printPdf(base64);
		}
	}, [open, base64]);

	const printPdf = (base64) => {
		const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
		const blob = new Blob([bytes], { type: "application/pdf" });
		const url = URL.createObjectURL(blob);

		let iframe = iframeRef.current;
		if (!iframe) {
			iframe = document.createElement("iframe");
			iframe.style.position = "fixed";
			iframe.style.right = "0";
			iframe.style.bottom = "0";
			iframe.style.width = "0";
			iframe.style.height = "0";
			iframe.style.border = "0";
			iframeRef.current = iframe;
			document.body.appendChild(iframe);
		}

		iframe.src = url;

		iframe.onload = () => {
			iframe.contentWindow.focus();
			iframe.contentWindow.print();
			setTimeout(() => URL.revokeObjectURL(url), 1000);
		};
	};

	return null;
};

export default PrintBase64Pdf;
